import {
  createSlice,
  PayloadAction
} from "@reduxjs/toolkit";
import store, { RootState } from "store";

interface IInitialState {
  visible: boolean,
  scoreData: any
}

const initialState: IInitialState = {
  visible: false,
  scoreData: {}
};

export const scoreSlice = createSlice({
  name: "score",
  initialState: initialState,
  reducers: {
    setVisible: (state, action: PayloadAction<any>) => {
      state.visible = action.payload;
    },
    setScoreModal: (state, action: PayloadAction<any>) => {
      state.scoreData = action.payload;
    }
  },
});

export const mapScoreVisible = (state: RootState) => state.score.visible;
export const mapScoreData = (state: RootState) => state.score.scoreData;
export const { setScoreModal, setVisible } = scoreSlice.actions;

export const setScoreData = (data: any) => {
  const dispatch = store.dispatch;
  dispatch(setScoreModal(data))
}

export const setScoreVisible = (visible: boolean) => {
  const dispatch = store.dispatch;
  dispatch(setVisible(visible))
};

export default scoreSlice.reducer;
